import { render, staticRenderFns } from "./kdmembers.vue?vue&type=template&id=425a74b1&scoped=true&"
import script from "./kdmembers.vue?vue&type=script&lang=js&"
export * from "./kdmembers.vue?vue&type=script&lang=js&"
import style0 from "./kdmembers.vue?vue&type=style&index=0&id=425a74b1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "425a74b1",
  null
  
)

export default component.exports